import _ from 'underscore';

import mainTranslationsInfo from '@jht/translations-loader?info!../../translations.csv';

export default angular.module('config', [])
.provider('config', function() {
    // Default config
    var defaultConfig = {
            basePath: '/', // Should match <base href=""> in index.html
            assetBaseUrl:  '',
            defaultLanguage: 'en',
            // Language key expected format: two letter ISO_639-1 code + region
            // http://www.w3.org/International/articles/language-tags/
            languages: {
                en: {
                    name: 'English'
                },
                de: {
                    name: 'Deutsch'
                },
                'zh-CN': {
                    name: '简体中国',
                    aliases: ['zh']
                },
                'zh-TW': {
                    name: '中國傳統'
                }
            },
            units: ['imperial', 'metric'],
            availableLanguages: [], // Generated from languages
            languageAliases: {},    // Generated from languages
            apiUrl: 'https://dev-am4-api.jfit.co',
            machinePlaceholderImage: 'https://placehold.it/150x150',
            errorCodeServiceRange: 10,
            equipmentErrorFreshnessCutoff: 72, // hours
            temporaryMessageTimeout: 3000,
            userRoles: [
                'ADMINISTRATOR',
                'CTS_ADVANCED',
                'CTS_BASIC',
                'INSIDE_SALES',
                'SALES_REP',
                'TECHNICIAN',
                'CUSTOMER_ADVANCED',
                'CUSTOMER_BASIC',
                'CUSTOMER_MARKETING',
                'ECO_FIT',
                'DIGITAL_ORDERING',
                'SERVICE_REQUESTS',
                'RSCU',
                'CORE_ACCESS',
                'CORE_ADMIN'
            ],
            defaultFacilityCountryISO3: 'USA',

            // Flatpickr formatting (https://chmln.github.io/flatpickr/formatting/)
            flatpickrDateFormat: 'Y-m-d\\TH:i:S', // e.g. '2017-03-23T06:05:00', '2017-03-23T14:25:00'
            flatpickrMomentFormat: 'YYYY-MM-DD[T]HH:mm:ss', // moment.js token equivalent
            flatpickrDisplayFormat: 'M J, Y H:i',
            flatpickrDisplayFormat12hr: 'M J, Y h:i K',
            externalCalendarEventDateFormat: 'MMMM Do YYYY, h:mm a z',

            welcomeScreenMaxFileSize: 5242880,
            welcomeScreenMaxNumber: 10
        },
        config = {};


    const languages = {};
    Object.keys(mainTranslationsInfo).forEach(code => {
        if (mainTranslationsInfo[code].LANGUAGE_NAME) {
            languages[code] = {
                name: mainTranslationsInfo[code].LANGUAGE_NAME
            };

            if (mainTranslationsInfo[code].LANGUAGE_ALIASES) {
                languages[code].aliases = mainTranslationsInfo[code].LANGUAGE_ALIASES;
            }
        }
    });

    config.languages = languages;

    _.defaults(config, window.config, defaultConfig);

    config.availableLanguages = _.map(config.languages, function(obj, key) {
        return key;
    });

    config.slowLoadTime = 5000;

    // TODO: Examine the necessity of all this aliasing and consider
    // replacing it with a language/region resolver that's used
    // directly by angular translate
    //
    // https://github.com/angular-translate/angular-translate/blob/a2ac7000f94bcee6dd8e206cab5d7cec3527dd25/src/service/translate.js#L694

    // Maps language_region to language-region.  zh_TW to zh-TW for example.
    function createUnderscoreAlias(name) {
        if (name.indexOf('-') > -1) {
            config.languageAliases[name.replace('-', '_')] = name;
        }
    }

    // Create map of aliases
    _.each(config.languages, function(obj, key) {
        _.each(obj.aliases, function(alias) {
            config.languageAliases[alias] = key;
            createUnderscoreAlias(alias);
        });

        if (key.length === 2) {
            config.languageAliases[key + '*'] = key;
        }

        createUnderscoreAlias(key);
    });

    if (config.buildTime && !_.contains(['www', 'staging'], config.env)) {
        config.showBuildTime = true;
    }

    this.config = config;

    this.$get = function() {
        return config;
    };
});



// WEBPACK FOOTER //
// ./src/app/config.js